export { umamiProvider as analytics } from './umami';
export type { AnalyticsProvider } from './types';
